import React from "react";
import Contact from "../Public_Components/Contact";



function Contact_Us() {
  return (
    <>
     
      
      <Contact/>
      
     
    </>
  );
}

export default Contact_Us;
